<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      code="choix-categorie"
      v-model="sasInscriptionTableauRegistre.typeDeCotisation"
      :live="liveSasInscriptionTableauRegistre(2314)"
      :code-filter="sas.typesCotisations"
      @eudo-updated="categorieChanged"
    ></opq-catalogue>

    <ressource v-show="estCongeParental" code="declaration-cp"></ressource>
    <opq-date-picker
      :opq-if="estCongeParental"
      :minYear="1990"
      code="date-debut-CP"
      v-model="sasInscriptionTableauRegistre.dateDebutCongeParental"
      :live="liveSasInscriptionTableauRegistre(2321)"
      disabled
      ref="dateDebutCP"
    >
    </opq-date-picker>
    <opq-date-picker
      :opq-if="estCongeParental"
      code="date-fin-CP"
      ref="dateFinCP"
      v-model="sasInscriptionTableauRegistre.dateFinCongeParental"
      :live="liveSasInscriptionTableauRegistre(2322)"
      :minYear="new Date(sasInscriptionTableauRegistre.dateDebutCongeParental).getFullYear()"
      :maxYear="new Date(sasInscriptionTableauRegistre.dateDebutCongeParental).getFullYear() + 2"
      :condition="
        (v) => {
          let diff = (new Date(v) - new Date(sasInscriptionTableauRegistre.dateDebutCongeParental)) / 1000 / 24 / 3600
          let premierAvrilAnneeEnCours = new Date(new Date().getFullYear(), 3, 1)
          return diff > 0 && diff <= 365 && new Date(v) >= premierAvrilAnneeEnCours
        }
      "
      conditionMessage="Une journée minimum et un an maximum"
    >
    </opq-date-picker>
    <opq-case
      :opq-if="estCongeParental"
      code="declaration-CP"
      v-model="sasInscriptionTableauRegistre.declarationCongeParental"
      :live="liveSasInscriptionTableauRegistre(2320)"
    ></opq-case>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import { mapActions } from "vuex"

export default {
  mixins: [CataloguesHelper, FormSimple],
  props: {
    sas: { type: Object }
  },

  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasInscriptionTableauRegistre(cle) {
      return { endpoint: "sas-inscriptions-tableau-registre", cle: cle, fileId: this.sasInscriptionTableauRegistre.id }
    },
    estCategorie(codeCategorie) {
      return this.getCatalogueCodeById(11124, this.sas.sasInscriptionAuTableauRegistre.typeDeCotisation) == codeCategorie
    },
    estType(codeType) {
      return this.getCatalogueCodeById(2312, this.sas.sasInscriptionAuTableauRegistre.typeDInscription) == codeType
    },
    async categorieChanged() {
      if (this.estCongeParental) {
        let dateReference = new Date()
        if (this.sas.congeParentalHorsQuebec.etaitCongeParental) {
          dateReference = new Date(this.sas.congeParentalHorsQuebec.dateDebutCongeParental)
        } else if (this.estRenouvellement) {
          dateReference = new Date(this.sas.dateDeRenouvellement)
        }
        await this.$refs.dateDebutCP.setValue(dateReference)
        this.$refs.dateFinCP.setYears()
        if (this.sas.congeParentalHorsQuebec.etaitCongeParental) {
          this.$refs.dateFinCP.setValue(new Date(this.sas.congeParentalHorsQuebec.dateFinCongeParental))
        }
      }

      await this.fetchPanier(this.sas.id)
    }
  },

  computed: {
    sasInscriptionTableauRegistre() {
      return this.sas.sasInscriptionAuTableauRegistre
    },
    estCongeParental() {
      return this.estCategorie(22) || this.estCategorie(24)
    },
    estRenouvellement() {
      return this.estType(2)
    }
  }
}
</script>

<style>
</style>